import React, { FC } from 'react'
import { Wrapper, Element } from './styled'

export const AdvantagesComponent: FC = () => (
	<Wrapper>
		<Element title="Гибкий тариф" text="Чем выше оборот, тем ниже комиссия" isIcon={false} />
		<Element
			title="Деньги — быстро"
			text="Зачисление — на следующий день до 12:00. Единой суммой или частями"
			isIcon={false}
		/>
		<Element
			title="Поддержка 24/7"
			text="Отвечаем в течение 30 секунд по телефону. Замена терминала — в течение 24 часов"
			isIcon={false}
		/>
		<Element
			title="Управление онлайн"
			text="Подключение услуг и дополнительных торговых точек через интернет-банк СберБизнес"
			isIcon={false}
		/>
	</Wrapper>
)
